<section *ngIf="loading">
  <h2>Loading...</h2>
  <mat-progress-bar mode="indeterminate" aria-label="Loading...">
  </mat-progress-bar>
</section>

<section *ngIf="processing">
  <h2>Processing...</h2>
  <mat-progress-bar mode="indeterminate" aria-label="processing...">
  </mat-progress-bar>
</section>

<section [hidden]="loading">
  <mat-card>
    <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">

      <button mat-raised-button color="primary" title="Add Interaction" (click)="add()" *ngIf="householdId > 0"><mat-icon>add</mat-icon> Add Interaction</button>
      <br />
      <strong class="noMarginHeader">Interactions ({{resultSize}})</strong>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <mat-form-field style="width:200px;">
        <input (keyup)="filterTable($event)" placeholder="Filter results" matInput />
      </mat-form-field>

      <br />
      <mat-table [dataSource]="dataSource" matSort #TableSort="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
        <mat-row>Results ({{resultSize}})</mat-row>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Interaction Id</mat-header-cell>
          <mat-cell *matCellDef="let result">
            <span *ngIf="result.id > 0">
              <a (click)="edit(result.id)" title="Edit {{result.id}}">{{result.id}}</a>
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="approvedByStaff">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Approved</mat-header-cell>
          <mat-cell *matCellDef="let result">
            <span style="white-space: pre-wrap" *ngIf="result.approvedByStaff == true">Yes</span>
            <span style="white-space: pre-wrap" *ngIf="result.approvedByStaff == false">No</span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="type">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Type</mat-header-cell>
          <mat-cell *matCellDef="let result">
            {{result.type}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="result">
          <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="15">Result</mat-header-cell>
          <mat-cell *matCellDef="let result" fxFlex="15">
            <span style="white-space: pre-wrap">{{result.result}}</span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="comment">
          <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="20">Comment</mat-header-cell>
          <mat-cell *matCellDef="let result" fxFlex="20">
            <span style="white-space: pre-wrap">{{result.comment}}</span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="updated">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Updated</mat-header-cell>
          <mat-cell *matCellDef="let result">
            {{result.lastUpdated}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef fxFlex="10">Actions</mat-header-cell>
          <mat-cell *matCellDef="let result" fxFlex="10">
            <a href="javascript:void(0)" *ngIf="result.id > 0 && !authService.isReadOnly()" (click)="delete(result.id)" title="Delete Interaction">
              <mat-icon>delete</mat-icon>
            </a>
          </mat-cell>
        </ng-container>
      </mat-table>
      <br />
      <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50]" #TablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
    </div>
  </mat-card>
</section>